import { render, staticRenderFns } from "./SelectClients.vue?vue&type=template&id=73196f52&"
import script from "./SelectClients.vue?vue&type=script&lang=js&"
export * from "./SelectClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports